import { Moon, Sunrise, Sunset } from 'lucide-react';
import type { DayBlock } from '../types';

export default function DayPanel({ day, timeZone }: { day: DayBlock; timeZone: string }) {
  const fmt = (iso: string) =>
    new Date(iso).toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      timeZone,
    });

  return (
    <section className="grid grid-cols-3 gap-2">
      <Card icon={<Sunrise className="w-4 h-4" />} label="Sunrise" value={fmt(day.sunrise)} />
      <Card icon={<Sunset className="w-4 h-4" />} label="Sunset" value={fmt(day.sunset)} />
      <Card
        icon={<Moon className="w-4 h-4" />}
        label={day.moonPhaseName}
        value={`${day.moonIllumPct}%`}
        sub="illumination"
      />
    </section>
  );
}

function Card({
  icon,
  label,
  value,
  sub,
}: {
  icon: React.ReactNode;
  label: string;
  value: string;
  sub?: string;
}) {
  return (
    <div className="bg-white/10 backdrop-blur-sm rounded-lg p-2.5">
      <div className="flex items-center gap-1.5 text-[10px] uppercase tracking-wider opacity-70">
        {icon}
        {label}
      </div>
      <div className="font-medium tabular-nums">{value}</div>
      {sub && <div className="text-[10px] opacity-60">{sub}</div>}
    </div>
  );
}
